// extracted by mini-css-extract-plugin
export default {"orderContainer":"ReorderableList-module__orderContainer--ZH6oX","draggableContainer":"ReorderableList-module__draggableContainer--jR0E+"};